import { BmiForm } from "./components/BmiForm";
import { BmiResultPanel } from "./components/BmiResultPanel";
import { BmiShell } from "./components/BmiShell";
import { useBmiCalculator } from "./hooks/useBmiCalculator";
import type { BmiAppSettings } from "./types";

export function BmiApp({ settings }: { settings: BmiAppSettings }) {
  const calculator = useBmiCalculator();

  return (
    <BmiShell settings={settings}>
      <main className="bmi-screen">
        <section className="bmi-intro">
          <p>BMI Calculator</p>
          <h1>Check your body mass index</h1>
        </section>
        <BmiForm
          state={calculator.state}
          onFieldChange={calculator.updateField}
          onImperialHeightModeChange={calculator.updateImperialHeightMode}
          onImperialWeightModeChange={calculator.updateImperialWeightMode}
          onUnitSystemChange={calculator.updateUnitSystem}
        />
        <BmiResultPanel result={calculator.result} />
      </main>
    </BmiShell>
  );
}
